
<div class="wide-attachments-container" v-if="wideItemAttachments && wideItemAttachments.length">
  <div class="wide-attachments label">Inline images</div>

  <div class="loaded-attachments cursor-pointer" v-for="attachment in wideItemAttachments" :key="attachment.id">
    <div class="attachment" @click="openAttachment(attachment)" ondragstart="return false;" ondrop="return false;">
      <img
        v-on:click.stop="openAttachment(attachment)"
        :src="apiUrl + '/Attachment/attachment/' + attachment.id"
        :data-src="apiUrl + '/Attachment/attachment/' + attachment.id"
        v-if="imageFileExtensions.indexOf(attachment.fileExtension) !== -1"
      />

      <div v-if="isLoading" class="spinner d-flex align-items-center justify-content-center p-5">
        <loading-spinner></loading-spinner>
      </div>

      <div
        class="update-attachment badgebutton active"
        v-b-tooltip:hover
        title="Display in list"
        v-on:click.stop="moveAttachmentToList(attachment)"
      >
        <i class="far fa-arrow-alt-down"></i>
      </div>

      <div
        class="delete-attachment badgebutton danger active"
        v-b-tooltip:hover
        title="Delete this attachment"
        v-on:click.stop="confirmDelete(attachment)"
      >
        <i class="far fa-trash"></i>
      </div>
    </div>
  </div>

  <a
    :id="hiddenId"
    @click="window_.open(blobAttachmentUrl, '_blank', 'location=yes,height=800,width=1200,scrollbars=yes,status=yes')"
  ></a>
</div>
